// libs
import React from 'react';
import PropTypes from 'prop-types';
import Sticky from 'react-sticky-el';
import { ProgramHeader } from 'shared';


export default class StickyHeader extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        boundaryElement: PropTypes.string
    }

    static defaultProps = {
        boundaryElement: '.sticky-container'
    }

    state = {
        currentSection: 'progress',
        hasViewPart: {},
        isFixed: false
    }

    handleFixedStateChange = isFixed => this.setState( { isFixed } )

    render() {
        const { children, boundaryElement } = this.props;
        const { isFixed } = this.state;

        return (
            <Sticky boundaryElement={boundaryElement} className="nav-bar" onFixedToggle={this.handleFixedStateChange}>
                <ProgramHeader isCollapsed={!isFixed} />
                { children }
            </Sticky>
        );
    }
}
